<template>
	<div class="view pdf-viewer-view" :class="{'is-folded': folded}">
		<HeaderBar :titleParam="title"
				   :folded="folded" />
		<div class="pdf-wrap"
			 @click="onCanvasWrapClick"
			 v-touch:tap="onCanvasWrapClick">

			<div ref="canvasWrap"
				 class="canvas-wrap">
				<pdf class="pdf-canvas"
					 :src="path"
					 :page="page"
					 @num-pages="pageCount = $event"
					 @loaded="onLoaded"
					 @progress="loadedRatio = $event">
				</pdf>
			</div>
			<pdf v-show="false"
				 :src="preLoadPath"
				 @loaded="onPreLoaded"></pdf>

		</div>
		<div class="tool-bar"
			 :class="{'is-folded': folded}">
			<van-button size="small"
						@click.stop="onResetClick">适合屏幕</van-button>
			<van-button size="small"
						@click.stop="onFirstClick"
						:disabled="realPage===1">首页</van-button>
			<van-button size="small"
						@click.stop="onPrev"
						:disabled="realPage===1">上页</van-button>
			<span>{{`${realPage}/${neaf_page}`}}</span>
			<van-button size="small"
						@click.stop="onNext"
						:disabled="realPage===neaf_page">下页</van-button>
			<van-button size="small"
						@click.stop="onLastClick"
						:disabled="realPage===neaf_page">末页</van-button>

		</div>
		<PopLoading v-show="showLoading" />
	</div>
</template>

<script>
import { Button } from 'vant'
import pdf from 'vue-pdf'
import panzoom from 'panzoom';
import apiUtil from '../../utils/apiUtil'
import apiConst from '../../consts/apiConst'
import HeaderBar from '../../components/HeaderBar'
import PopLoading from '../../components/PopLoading'
export default {
	name: 'pdfViewer',
	components: {
		'van-button': Button,
		pdf,
		HeaderBar,
		PopLoading
	},
	data() {
		return {
			title: '',
			neaf_page: 0,
			neaf: [],
			index: -1,
			path: '',
			pageCount: 0, // 当前pdf碎片的总页数
			page: 1, // 当前页在pdf碎片的页码
			realPage: 1, // 当前页在总pdf的页码
			preLoadPath: '', // 预加载的
			isPreloaded: false, // 是否预加载完成
			showLoading: false,
			loadedRatio: 0,
			type: 0, // 2-digital 3-course
			zoomInstance: null,
			x: 0,
			y: 0,
			scale: 1,
			lastFlag: false, // 点了末页之后，置为true，loaded之后pageCount赋值之后再置为false
			folded: false
		}
	},
	created() {
		const { type, id, index } = this.$route.query
		const intType = parseInt(type)
		this.type = intType
		if (intType === 3) {
			this.initCourse(id, index)
		} else if (intType === 2) {
			this.initDigital(id, index)
		}
	},
	watch: {
		loadedRatio(val) {
			console.log(val)
		}
	},

	methods: {
		async initCourse(id, index) {
			const res = await apiUtil.post(apiConst.getCourseDetail, {
				course_id: id
			})
			if (res.list) {
				const { sub_dir, title } = res.list
				const { neaf, neaf_page, path } = sub_dir[index]
				this.neaf = neaf
				this.neaf_page = neaf_page
				this.title = title
				if (neaf.length > 0) {
					this.path = neaf[0]
					this.index = 0
					this.showLoading = true
				}
			}
		},

		async initDigital(id, dir_id) {
			const res = await apiUtil.post(apiConst.getDigitalDetail, {
				id,
				dir_id
			})
			if (res && res.success) {
				const { title } = res.list
				const { neaf, neaf_page, whole_pdf } = res
				this.neaf = neaf
				this.neaf_page = neaf_page
				this.title = title
				if (neaf.length > 0) {
					this.path = neaf[0]
					this.index = 0
					this.showLoading = true
				}
			}
		},

		onCanvasWrapClick() {
			this.folded = !this.folded
		},
		onResetClick() {
			console.log(this.instance)
			this.instance.zoomAbs(0, 0, 1)
		},
		onFirstClick() {
			this.page = 1
			this.realPage = 1
			this.path = this.neaf[0]
		},
		onLastClick() {
			if (this.type === 3) {
				this.path = this.neaf[this.neaf.length - 1];
				this.index = this.neaf.length - 1;
				this.showLoading = true;
			} else if (this.type === 2) {
				this.page = this.pageCount
			}
			this.realPage = this.neaf_page;
		},
		onNext() {
			if (this.page < this.pageCount) {
				this.page++
				this.realPage++
			} else if (this.page === this.pageCount) {
				if (this.index === this.neaf.length - 1) {
					return;
				}
				this.path = this.preLoadPath
				this.page = 1
				this.realPage++
				this.index++
				if (!this.isPreloaded) {
					this.showLoading = true
				}
			}
			this.instance.zoomAbs(0, 0, 1)


		},
		onPrev() {
			if (this.page > 1) {
				this.page--
				this.realPage--
			} else if (this.page === 1) {
				if (this.index === 0) {
					return;
				}
				this.preLoadPath = this.path
				this.path = this.neaf[this.index - 1]
				this.index--
				this.realPage--
				this.page = this.pageCount
			}
			this.instance.zoomAbs(0, 0, 1)



		},
		onLoaded() {
			this.instance = panzoom(this.$refs.canvasWrap, {
				smoothScroll: false,
				minZoom: 1,
				maxZoom: 3

			});
			this.instance.on('zoom', e => {
				let { x, y, scale } = e.getTransform();
				if (scale === 1) {
					x = 0;
					y = 0;
					e.moveTo(0, 0);
				}
				this.x = x;
				this.y = y;
				this.scale = scale;
			});

			this.showLoading = false
			if (this.index < this.neaf.length - 1) {
				this.preLoadPath = this.neaf[this.index + 1]
				this.isPreloaded = false
				this.$nextTick(() => {
					if (this.lastFlag) {
						console.log(this.pageCount)
						this.page = this.pageCount;
						this.lastFlag = false;
					}
				})

			}
		},
		onPreLoaded() {
			this.isPreloaded = true
			this.showLoading = false
		},
		onProgress(e) {
			console.log(e)
		}
	}
}
</script>
<style lang="stylus" scoped>
.pdf-viewer-view {
	height: 100%;
	&.is-folded {
		padding-top: 0;
	}

	.tool-bar {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0px;
		height: 88px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 20px;
		z-index: 9;
		background-color: #fff;
		border-top: 1PX solid #f1f1f1;
		transition: all 0.2s linear;

		&.is-folded {
			bottom: -88px;
		}

		.van-button {
			&::before {
				content: '';
				display: inline-block;
				vertical-align: middle;
				width: 0;
				height: 100%;
				margin-top: 1PX;
			}
		}

		.van-button--default {
			background-color: #909090;
			color: #fff;
			border-color: #909090;
		}
	}

	.pdf-wrap {
		overflow: auto;
		-webkit-overflow-scrolling: touch;
		width: 100%;
		height: 100%;
		position: relative;
		overflow-x: hidden;
		overflow-y: auto;

		.canvas-wrap {
			margin-bottom: 80px;
		}
	}
}
</style>
